// eslint-disable-next-line no-unused-vars
import React from 'react';
//import Container from './Container';
import Container from 'flexbiz-core/components/AppContainer'

import withContainer from "./withContainer";
import withModule from '../../withModule';
import Home from "./Home";
const routes=[
    {
        id:'home',
        path: "/",
        component: Home,
        exact:true
    },
    {
        id:'data_list_config',
        path: "/data_list_config",
        component: withModule('accounting/DataListConfigManager.jsx'),
        exact:true
    },
    {
        id:'dashboardbycode',
        path: "/dashboard/:code",
        component: Home,
        exact:true
    },
    {
        id:'dashboard',
        path: "/dashboard",
        component: Home,
        exact:true
    },
    {
        id:'DashboardBroker',
        path: "/broker",
        component: withModule('broker/Dashboard.jsx'),
        exact:true
    },
    {
        id:'SalesReportPage',
        path: "/ctv-report",
        component: withModule('broker/SalesReportPage.jsx'),
        exact:true
    },
    {
        id:'BrokerSalesHistoryPage',
        path: "/ctv-sales-history",
        component: withModule('broker/BrokerSalesHistoryPage.jsx'),
        exact:true
    },

    {
        id:'OrderDetailPage',
        path: "/ctv-sales-detail/:id",
        component: withModule('broker/OrderDetailPage.jsx'),
        exact:true
    },
    {
        id:'MyProductsPage',
        path: "/my-products",
        component: withModule('broker/MyProductsPage.jsx'),
        exact:true
    },
    {
        id:'SalesBroker',
        path: "/ctv-sales/:ma_dt",
        component: withModule('broker/SalesPage.jsx'),
        exact:true
    },
    {
        id:'NetworkPage',
        path: "/ctv-network",
        component: withModule('broker/NetworkPage.jsx'),
        exact:true
    },
    {
        id:'CustomerListPage',
        path: "/ctv-customer",
        component: withModule('broker/CustomerListPage.jsx'),
        exact:true
    },
    {
        id:'customer-care',
        path: "/customer-care/:ma_kh",
        component: withModule('broker/CustomerCarePage.jsx'),
        exact:true
    },
    {
        id:'CustomerFunnelPage',
        path: "/customer-funnel",
        component: withModule('broker/CustomerFunnelPage.jsx'),
        exact:true
    },

    {
        id:'ReferralPage',
        path: "/referral",
        component: withModule('broker/ReferralPage.jsx'),
        exact:true
    },

    

    {
        id:'profile',
        path: "/profile",
        component: withModule("Profile"),
        //isDialog:true,
        exact:true
    },
    {
        id:'cart',
        path: "/cart",
        isDialog:true,
        component: withContainer(Container)(withModule("Cart")),
        exact:true
    },
    {
        id:'notifications',
        path: "/notifications",
        isDialog:true,
        component: withModule("Notifications"),
        exact:true
    },
    {
        id:'mine',
        path: "/mine",
        component: withModule("Mine"),
        exact:true
    },
    {
        id:'agent',
        path: "/daily",
        component: withModule('DashboardDaiLy'),
        exact:true
    },
    {
        id:'chat',
        path: "/chat",
        isDialog:true,
        component: withModule('Chat'),
    },

    {
        id:'frm',
        path: "/m/:module/frm/:id",
        component: withContainer(Container)(withModule('financial/FRMpage')),
    },
    {
        id:'frm',
        path: "/frm/:id",
        component: withContainer(Container)(withModule('financial/FRMpage')),
    },
    {
        id:'workflow',
        path: "/page/workflow/:code",
        component: withModule('accounting/WorkFlow.jsx'),
        exact:true
    },
    {
        id:'dynamicpage',
        path: "/page/:type/:code",
        component: withModule('accounting/DataDynamicPage.jsx'),
        exact:true
    },
    {
        id:'m-list',
        path: "/m/:module/list/:code",
        
        component:  withContainer(Container)(withModule("accounting/List")),
        exact:true
    },
    {
        id:'m-voucher',
        path: "/m/:module/voucher/:code",
        
        component: withContainer(Container)(withModule("accounting/Voucher")),
        exact:true
    },
    {
        id:'m-report',
        path: "/m/:module/report/:code",
        component: withContainer(Container)(withModule("accounting/Report")),
        exact:true
    },
    {
        id:'appInfo',
        path: "/m/:module/system/appinfo",
        component: withContainer(Container)(withModule('AppInfo')),
    },
    
    {
        id:'timelinetask',
        path: "/m/:module/timeline-task",
        component:withContainer(Container)(withModule('task/TimelineTask')),
    },
    {
        id:'timelinetask',
        path: "/timeline-task",
        component: withContainer(Container)(withModule('task/TimelineTask')),
    },

    {
        id:'grantttask',
        path: "/m/:module/grantt-task",
        component: withContainer(Container)(withModule('task/GranttTask')),
    },
    {
        id:'grantttask',
        path: "/grantt-task",
        component: withContainer(Container)(withModule('task/GranttTask')),
    },

    {
        id:'grouptask',
        path: "/m/:module/group-task",
        component: withContainer(Container)(withModule('task/GroupTask')),
    },
    {
        id:'grouptask',
        path: "/group-task",
        component: withContainer(Container)(withModule('task/GroupTask')),
    },

    {
        id:'gridtask',
        path: "/m/:module/banlamviec",
        component: withContainer(Container)(withModule('task/GridTask')),
    },
    {
        id:'gridtask',
        path: "/banlamviec",
        component: withContainer(Container)(withModule('task/GridTask')),
    },

    {
        id:'viewtask',
        isDialog:true,
        path: "/task/:_id",
        component: withContainer(Container)(withModule('task/ViewTask')),
    },
    {
        id:'dmbp',
        path: "/dmbp",
        
        component: withContainer(Container)(withModule('hrm/dmbp')),
    },
    {
        id:'dmbp',
        path: "/m/:module/dmbp",
        
        component: withContainer(Container)(withModule('hrm/dmbp')),
    },
    {
        id:'lenhsxview',
        path: "/m/:module/voucher/lenhsx/:_id",
        component: withContainer(Container)(withModule('accounting/views/LenhsxView')),
    },
    {
        id:'congdoanview',
        path: "/m/:module/list/congdoansx/:_id",
        component: withContainer(Container)(withModule('accounting/views/CongdoanView')),
    },
    {
        id:'productuser',
        path: "/pu/:app_code/:so_seri",
        component: withModule('ProductUser'),
    },
    {
        id:'search',
        path: "/search/:search_text",
        
        component: withContainer(Container)(withModule('Search')),
        exact:true
    },
    {
        id:'module',
        path: "/m/:module",
        
        component: withContainer(Container)(withModule('Module')),
        exact:true
    },
    {
        id:'t',
        path: "/t/:code",
        component: withModule('T'),
    },
    {
        id:'list',
        path: "/list/:code",
        
        component: withContainer(Container)(withModule("accounting/List")),
    },
    
    {
        id:'view',
        isDialog:true,
        path: "/view/:code/:_id",
        component: withContainer(Container)(withModule('View')),
    },
    {
        id:'voucher',
        path: "/voucher/:code",
        
        component: withContainer(Container)(withModule("accounting/Voucher")),
    },

    {
        id:'quicklist',
        path: "/quicklist/:code",
        
        component: withContainer(Container)(withModule("accounting/List")),
    },
    {
        id:'quickinput',
        isDialog:true,
        path: "/quickinput/:code",
        component: withContainer(Container)(withModule("accounting/QuickInput")),
    },
    {
        id:'report',
        path: "/report/:code",
        
        component: withContainer(Container)(withModule("accounting/Report")),
    },
   

    {
        id:'Flow',
        path: "/m/:module/floweditor/:flow_id",
        component: withContainer(Container)(withModule('Flow')),
    },

    {
        id:'Flow',
        path: "/floweditor/:flow_id",
        component: withContainer(Container)(withModule('Flow')),
    },

    {
        id:'ProductManagement',
        path: "/ProductManagement",
        
        component: withContainer(Container)(withModule('sys/ProductManagement')),
    },
    {
        id:'ProductManagement',
        path: "/m/:module/ProductManagement",
        
        component: withContainer(Container)(withModule('sys/ProductManagement')),
    },

    
    {
        id:'filemanagement',
        path: "/filemanagement",
        
        component: withContainer(Container)(withModule('sys/FileManagement')),
    },
    {
        id:'filemanagement',
        path: "/m/:module/filemanagement",
        
        component: withContainer(Container)(withModule('sys/FileManagement')),
    },

    {
        id:'DiscountManagement',
        path: "/discountmanagement",
        
        component: withContainer(Container)(withModule('sys/DiscountManagement')),
    },
    {
        id:'DiscountManagement',
        path: "/m/:module/discountmanagement",
        
        component: withContainer(Container)(withModule('sys/DiscountManagement')),
    },

    {
        id:'CustomerManagement',
        path: "/customermanagement",
        
        component: withContainer(Container)(withModule('sys/CustomerManagement')),
    },
    {
        id:'CustomerManagement',
        path: "/m/:module/customermanagement",
        
        component: withContainer(Container)(withModule('sys/CustomerManagement')),
    },

    {
        id:'BdsManagement',
        path: "/bdsmanagement",
        
        component: withContainer(Container)(withModule('sys/BdsManagement')),
    },
    {
        id:'BdsManagement',
        path: "/m/:module/bdsmanagement",
        
        component: withContainer(Container)(withModule('sys/BdsManagement')),
    },

    
    {
        id:'usergroup',
        path: "/usergroup",
        
        component: withContainer(Container)(withModule('sys/UserManagement')),
    },
    {
        id:'usergroup',
        path: "/m/:module/usergroup",
        
        component: withContainer(Container)(withModule('sys/UserManagement')),
    },
    

    {
        id:'appInfo',
        path: "/system/appinfo",
        component: withContainer(Container)(withModule('AppInfo')),
    },
    
    
    //okr
    {
        id:'okr',
        path: "/okr/:_id",
        component: withContainer(Container)(withModule('okr/OkrView')),
    },
    {
        id:'keyresultview',
        path: "/keyresult/:_id",
        component: withContainer(Container)(withModule('okr/KeyresultView')),
    },
    //experience journey
    {
        id:'experiencejourneyView',
        path: "/experience-journey/data/:idJourney",
        component: withContainer(Container)(withModule('experiencejourney/DataPage')),
    },
    {
        id:'experiencejourneySetup',
        path: "/experience-journey/setup/:idJourney",
        component: withContainer(Container)(withModule('experiencejourney/SetupPage')),
    },
    //strategic
    {
        id:'strategicdiagram',
        path: "/strategicdiagram/:id_link",
        component: withContainer(Container)(withModule('strategic/StrategicDiagram')),
    },
    {
        id:'strategicplan',
        path: "/strategicplan/:_id",
        component: withContainer(Container)(withModule('strategic/StrategicPlanView')),
    },
    {
        id:'strategicgoal',
        path: "/strategicgoal/:_id",
        component: withContainer(Container)(withModule('strategic/StrategicGoalView')),
    },
    {
        id:'strategicobjective',
        path: "/strategicobjective/:_id",
        component: withContainer(Container)(withModule('strategic/StrategicObjectiveView')),
    },
    {
        id:'strategickpi',
        path: "/strategickpi/:_id",
        component: withContainer(Container)(withModule('strategic/StrategickpiView')),
    },
    {
        id:'bmc',
        path: "/bmc/:_id",
        component: withContainer(Container)(withModule('bmc/Bmc')),
    },
    //
    {
        id:'404',
        path: "/404",
        component: withContainer(Container)(withModule('NotFound')),
        exact: true,
    }

]
export default routes;
